import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthState } from '@app/core/auth/states/auth.state';
import { App } from '@app/core/models/app.model';
import { AppState } from '@app/core/states/app.state';
import { ToggleSidenavCollapsed } from '@app/ui/states/ui.actions';
import { UIState } from '@app/ui/states/ui.state';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'rk-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @Select(AuthState.currentUsername)
  userName$: Observable<string>;
  @Select(AuthState.userLang)
  userLang$: Observable<string>;
  @Select(UIState.isCreationProcess)
  isCreationProcess$: Observable<boolean>;
  @Select(AppState.apps)
  apps$: Observable<App[]>;
  @Select(AppState.currentAppIsNotOwnedByUser)
  currentAppIsNotOwnedByUser$: Observable<boolean>;
  @Select(UIState.sidenavCollapsed)
  sidenavCollapsed$: Observable<boolean>;

  isLocal = !environment.production;
  headwayEn = '7N2LA7';
  headwayFr = 'xYOvAJ';

  private readonly subscription: Subscription = new Subscription();

  constructor(
    private readonly translateService: TranslateService,
    private readonly router: Router,
    private readonly store: Store,
  ) {}

  ngAfterViewInit(): void {
    this.userLang$.subscribe(lang => {
      const config = {
        selector: '.headway-widget', // CSS selector where to inject the badge
        account: lang === 'fr' ? this.headwayFr : this.headwayEn,
        translations: {
          title: this.translateService.instant('changelog.title'),
          readMore: this.translateService.instant('changelog.read-more'),
          labels: {
            new: this.translateService.instant('changelog.new'),
            improvement: this.translateService.instant('changelog.improvement'),
            fix: this.translateService.instant('changelog.fixes'),
          },
          footer: this.translateService.instant('changelog.read-more'),
        },
      };
      let tries = 0;
      const itv = setInterval(() => {
        // @ts-ignore
        if (typeof Headway !== 'undefined') {
          // @ts-ignore
          Headway.init(config);
          clearInterval(itv);
        }
        tries += 1;
        if (tries === 10) {
          clearInterval(itv);
        }
      }, 500);
    });
  }

  toggleSidenav() {
    this.store.dispatch(new ToggleSidenavCollapsed());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
